import { Action } from 'redux';
import {  
  IEtrmConfig,
} from '../../services';

export interface IEtrmConfigState {
  loading?: boolean;
  etrmConfigs?: IEtrmConfig[];
  etrmConfig?: IEtrmConfig;
  exceptionMessage?: string;
  message?: string;
  isEtrmConfigPostSuccess?: boolean;
}

export enum EtrmConfigActionEnum {
  FetchEtrmConfig = '@@EtrmConfig/FETCH_EtrmConfig',
  FetchEtrmConfigSuccess = '@@EtrmConfig/FETCH_EtrmConfig_SUCCESS',
  FetchEtrmConfigFailed = '@@EtrmConfig/FETCH_EtrmConfig_FAILED',  
  PostEtrmConfig = '@@EtrmConfig/POST_EtRMConfig',
  PostEtrmConfigSuccess = '@@EtrmConfig/POST_EtRMConfig_SUCCESS',
  PostEtrmConfigFailed = '@@EtrmConfig/POST_EtRMConfig_FAILED'
}

export interface IFetchEtrmConfigAction
    extends Action<typeof EtrmConfigActionEnum.FetchEtrmConfig> {
    state?: IEtrmConfigState;
}

export interface IFetchEtrmConfigSuccessAction
    extends Action<typeof EtrmConfigActionEnum.FetchEtrmConfigSuccess> {
    state?: IEtrmConfigState;
}

export interface IFetchEtrmConfigFailedAction
    extends Action<typeof EtrmConfigActionEnum.FetchEtrmConfigFailed> {
    state?: IEtrmConfigState;
}

export interface IPostEtrmConfigAction
  extends Action<typeof EtrmConfigActionEnum.PostEtrmConfig> {
    state?: IEtrmConfigState;
}

export interface IPostEtrmConfigSuccessAction
  extends Action<typeof EtrmConfigActionEnum.PostEtrmConfigSuccess> {
    state?: IEtrmConfigState;
}

export interface IPostEtrmConfigFailedAction
  extends Action<typeof EtrmConfigActionEnum.PostEtrmConfigFailed> {
    state?: IEtrmConfigState;
}

export type EtrmConfigActions =
  | IFetchEtrmConfigAction
  | IFetchEtrmConfigSuccessAction
  | IFetchEtrmConfigFailedAction
  | IPostEtrmConfigAction
  | IPostEtrmConfigSuccessAction
  | IPostEtrmConfigFailedAction

